import type { HTMLComponent } from "@commercekit/react";
import type { RichTextSliceRichTextWithoutHeading } from "prismicio-types";
import { asText } from "@prismicio/helpers";
import { useMemo } from "react";
import { wrapIframe } from "@commercekit/shared";

const WvRichTextWithoutHeading: HTMLComponent<{
  slice: RichTextSliceRichTextWithoutHeading;
}> = ({ slice }) => {
  const content = useMemo(() => {
    return wrapIframe(asText(slice?.primary?.rich_content));
  }, [slice?.primary?.rich_content]);
  return (
    <div className="col-12 px-0">
      <div className="container">
        <div className="row">
          <div className="col-12 ">
            <div
              className="content"
              dangerouslySetInnerHTML={{
                __html: content || "",
              }}
            ></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WvRichTextWithoutHeading;
